'use client'

import { HorizontalScroll } from 'fukku/HorizontalScroll'
import type { OptionsProps } from 'plp/types/QuickFilters'

import { Option } from './Option/Option'

import styles from './Options.module.scss'

const TOO_MANY_ITEMS = 6

export function Options({
	data,
	showAsMediumOrSmall,
	catalogId,
	collection,
}: OptionsProps) {
	const showWithFewItemsRatio =
		data.length <= TOO_MANY_ITEMS || showAsMediumOrSmall

	const items = data.map((item, indexItem) => {
		if (item.image) {
			const hasCollection = item.collection ? `:${collection ?? ''}` : ''
			return (
				<Option
					key={`${item.catalogId}${item.collection ?? ''}`}
					item={item}
					isActive={
						item.catalogId === `${catalogId}${hasCollection}` ||
						(!collection && indexItem === 0)
					}
					showWithFewItemsRatio={showWithFewItemsRatio}
					indexItem={indexItem}
				/>
			)
		}
		return null
	})

	const currentPosition = data.findIndex((item) => {
		const hasCollection = item?.collection ? `:${collection ?? ''}` : ''
		return item?.catalogId === `${catalogId}${hasCollection}`
	})

	return (
		<div
			className={styles.container}
			data-testid='plp.quickfilters.squared.options'
		>
			{showAsMediumOrSmall ? (
				<HorizontalScroll
					showPaddingCarousel={false}
					className={styles.horizontalScroll}
					showHeader={false}
					titleProps={{ content: '', className: '' }}
					data-testid='plp.quickfilters.squared.horizontalScroll'
					initialPosition={currentPosition}
				>
					{items}
				</HorizontalScroll>
			) : (
				items
			)}
		</div>
	)
}
